
/**
 * @name Courtesies.js
 * @author Fellipe Orsini
 * @package clinic-mvp\app\assets\js\Suppliers.js
 */

//import { apiCall, getBaseDir } from './utils.js';

import TableBuilder from '../../table_builder.js';
var getBaseDir = null, apiCall = null, getBranchNameFromId = null, getSecUsers = null;

$(function()
{
    import('../../utils.js').then(utils => {
        getBaseDir = utils.getBaseDir;
        apiCall = utils.apiCall;
        getBranchNameFromId = utils.getBranchNameFromId;
        getSecUsers = utils.getSecUsers;

        if (!utils.isUserLoggedIn())
            return;

        // A partir dessa parte só vai executar os códigos abaixo quando estiver na página inicial
        if (location.pathname !== utils.getBaseDir() + 'financeiro/fornecedores')
            return;

        new FinancialSuppliers(true, {
            getBaseDir: utils.getBaseDir,
            apiCall: utils.apiCall,
        });
    });
});

class FinancialSuppliers
{
    constructor(onloadList=false, deps = {})
    {
        
        this.deps = deps;
        let self = this;
        this.tableHandler = new TableBuilder({
            table: '#table-financial-suppliers-list',
            tableBody: '.js-financial-suppliers-registrations-table',
            data: [],
            rowsPerPage: $('.js-suppliers-per-page').val(),
            filter: false,
            maxPages: 0,
            customId: "CrudSuppliersHandler",
            tableRowRenderer: function(rowData) {
                return self.mountTableRow(rowData);
            },
            OnClickFirstPage: function() {
                self.fetchSuppliersList();
            },
            OnClickLastPage: function() {
                self.fetchSuppliersList();
            },
        });

        this.fetchSuppliersList();
        this.bindDomEvents();
    }

    fetchSuppliersList() {
        let self = this;
        $(".js-financial-suppliers-registrations-table").block(window._loader.loading);
        if (this.fetchRequest) {
            if (typeof this.fetchRequest.abort === 'function')
                this.fetchRequest.abort();
            this.fetchRequest = null;
        }
        this.fetchRequest =apiCall({
            method: 'GET',
            endpoint: 'api/v1/financial/suppliers',
            data: {
                search: self.searchQuery,
                page: self.tableHandler.getCurrentPage(),
                rowsPerPage: 10,
            },
            successCallback: function(res) {
                $(".js-financial-suppliers-registrations-table").unblock();
                if (!res.error) {
                    self.suppliersList = res.data;
                    self.suppliersTotal = res.total;
                    self.tableHandler.renderPage(self.tableHandler.getCurrentPage(), false, self.suppliersList, false, self.suppliersTotal);
                } else {
                    window.toast({
                        error: res.error,
                        text: res.message
                    })
                }
            },
            errorCallback: function(err) {
                $(".modal-edit-patient-dialog").unblock();
            }
        });
    }

    mountTableRow = (supplier) => {
        let row = `<tr>
            <td>${supplier.ID}</td>
            <td>${supplier.NOME}</td>
            <td>${supplier.RAZAO_SOCIAL}</td>
            <td>${supplier.CNPJ}</td>
            <td>${supplier.ATIVO == 1 ? 'Sim' : 'Não'}</td>
            <td>
                <button class="btn btn-sm btn-primary js-edit-supplier" data-info='${JSON.stringify(supplier)}'><i class="fas fa-edit"></i></button>
            </td>
        </tr>`;

        return row;
    }

    bindDomEvents = () => {
        let self = this;
        let currentEditSupplierId = null;

        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = $(this).text();
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-previous-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() - 1; //console.log('previous pageId', pageId);
            if (pageId <= 0)
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        });
        // Detecta alteração de página na tabela
        $(document).on('click', `.js-pagination-next-page-${self.tableHandler.getTableId()}`, function(e) {
            e.preventDefault();
            let pageId = self.tableHandler.getCurrentPage() + 1; //console.log('next pageId', pageId);
            if (pageId > self.tableHandler.getMaxPages())
                return;
            self.tableHandler.setCurrentPage(pageId); //console.log('pageId', pageId);
            self.fetchContractsList();
        }); 
        // Detecta busca por fornecedor
        $('.js-suppliers-name-filter').on('input', function() {
            // make a typing debounce
            clearTimeout(self.searchQueryTimeout);
            self.searchQueryTimeout = setTimeout(function() {
                self.searchQuery = $('.js-suppliers-name-filter').val().trim();
                if (self.searchQuery.length > 2) {
                    self.fetchSuppliersList();
                } else if (self.searchQuery.length == 0) {
                    self.searchQuery = '';
                    self.fetchSuppliersList();
                }
            }, 500);
        })

        $(document).on('click', '.js-edit-supplier', function() {
            let supplierInfo = $(this).data('info');
            currentEditSupplierId = supplierInfo.ID;

            $('#financial-supplier-edit-name').val(supplierInfo.NOME);
            $('#financial-supplier-edit-company-name').val(supplierInfo.RAZAO_SOCIAL);
            $('#financial-supplier-edit-cnpj').val(supplierInfo.CNPJ);
            $('#financial-supplier-edit-active').val(supplierInfo.ATIVO);
            $('#modal-financial-supplier-edit').modal('show');
        });

        $(document).on('hidden.bs.modal', '#modal-financial-supplier-create', function() {
            currentEditSupplierId = null;
        });

        $(document).on('submit', '.js-financial-supplier-create-form,.js-financial-supplier-edit-form', function(e) {
            e.preventDefault();
            let editOrCreate = currentEditSupplierId != null ? 'edit' : 'create';
            let data = $(this).serializeArray();
            $('#modal-financial-supplier-' + editOrCreate).block(window._loader.loading);
            if (currentEditSupplierId != null)
                data.push({
                    name: 'financial-supplier-edit-id',
                    value: currentEditSupplierId
                })
            apiCall({
                endpoint: 'api/v1/financial/supplier',
                method: currentEditSupplierId ? 'PUT' : 'POST',
                data: data,
                successCallback: function(body) {
                    $('#modal-financial-supplier-' + editOrCreate).unblock(window._loader.loading);
                    window.toast({
                        error: body.error,
                        text: body.message
                    })
                    $('.js-financial-supplier-'+editOrCreate+'-form').trigger('reset');
                    $('#modal-financial-supplier-' + editOrCreate).modal('hide');
                    self.fetchSuppliersList();
                },
                errorCallback: function(err) {
                    $('#modal-financial-supplier-' + editOrCreate).unblock(window._loader.loading);
                    window.toast({
                        error: true,
                        text: "Ocorreu um erro ao realizar a requisição."
                    })
                }
            })
        });
    }
}